/**
 * Build-time feature gates for reports whose backend is not yet safe to show.
 *
 * Appointment Optimization: the API behind /analytics/appointment-optimization used to return
 * invented figures (fixed in backend/services/analytics_service.py). Production runs the old
 * backend until it is redeployed, so the page stays off unless the build explicitly opts in
 * with VITE_ENABLE_APPOINTMENT_OPTIMIZATION=true (set it only after that backend is live).
 */
export const isAppointmentOptimizationEnabled = (): boolean =>
  import.meta.env.VITE_ENABLE_APPOINTMENT_OPTIMIZATION === 'true';
